<template>
  <!--子页面公共头部-->
  <div class="header-module">
    <!-- <div v-if="isIn919" class="header-919">
      <div class="header-919-inner">
        <img :src="activeInfo919.imgBanner" alt="" />
      </div>
    </div> -->
    <div class="header-box">
      <!-- <div class="logo" @click="innerHrefOpen('Home')"><img src="https://i0.ulecdn.com/sites/ule/img/home/new/logo.png" /></div> -->
      <div class="logo" @click="innerHrefOpen('Home')">
        <img v-if="isIn919" :src="activeInfo919.imgLogo" alt="" />
        <template v-else>
          <div class="floor1">
            <img
              class="logo-yz"
              src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_logo_yz.png"
              alt=""
            />
            <i></i>
            <img
              class="logo-ule"
              src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_logo_ule.png"
              alt=""
            />
          </div>
          <p class="floor2">乡村振兴综合生态互联网平台</p>
        </template>
      </div>
      <div class="menu-box">
        <div class="menu-item">
          <ul>
            <li
              v-for="(item, index) in menuList"
              :key="index"
              :class="[
                item.icon,
                isIn919 ? 'in919' : '',
                pathName == item.href ||
                (!item.href && isServer() && item.name == '产品及服务') ||
                (!item.href && isServer2() && item.name == '关于我们')
                  ? 'on'
                  : ''
              ]"
            >
              <div v-if="item.href == 'Index'" class="icon-pre">
                <img v-if="isIn919" :src="activeInfo919.iconNpActive" alt="" />
                <img
                  v-else
                  :src="
                    pathName == item.href
                      ? 'https://i0.ulecdn.com/sites/ule/img/home/new/icon-shopping-active.png'
                      : 'https://i0.ulecdn.com/sites/ule/img/home/new/icon-shopping.png'
                  "
                  alt=""
                />
              </div>
              <a
                :class="
                  pathName == item.href ||
                  (!item.href && isServer() && item.name == '产品及服务') ||
                  (!item.href && isServer2() && item.name == '关于我们')
                    ? 'on'
                    : ''
                "
                @click="toOpenPage(item)"
                >{{ item.name }}</a
              >
              <div class="list-box" v-if="item.subMenu">
                <span
                  v-for="(item2, index2) in item.subMenu"
                  :key="index2"
                  @click="toOpenPage(item2)"
                  >{{ item2.name }}</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="slogan">
        <img src="https://i0.ulecdn.com/sites/ule/img/home/new/slogan.png" />
      </div>
      <div class="user-center">
        <a
          href="https://my.ule.com/usr/profile/newsecurityIndex.do"
          target="_blank"
          >个人中心</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState } from "vuex";
export default {
  name: "SubHeader",
  data() {
    return {
      currIndex: 0,
      pathName: "",
      serverUrl: false,
      menuList: [
        {
          name: "首页",
          href: "Home"
        },
        {
          name: "关于我们",
          href: "",
          icon: "select-box-gywm",
          subMenu: [
            {
              name: "公司简介",
              href: "Gsjj"
            },
            {
              name: "组织架构",
              href: "Zzjg"
            },
            {
              name: "发展历程",
              href: "Fzlc"
            },
            {
              name: "企业文化",
              href: "Qywh"
            }
          ]
        },
        {
          name: "产品及服务",
          href: "",
          icon: "select-box",
          subMenu: [
            {
              name: "邮掌柜",
              href: "yzg"
            },
            {
              name: "邮政农品",
              href: "yznp"
            },
            {
              name: "邮乐商城",
              href: "ylsc"
            },
            {
              name: "邮乐小店",
              href: "ylxd"
            },
            {
              name: "邮乐直播",
              href: "ylzb"
            },
            {
              name: "邮乐优鲜",
              href: "ylyx"
            },
            {
              name: "邮生活",
              href: "ysh"
            },
            {
              name: "物流服务",
              href: "wlcx"
            },
            {
              name: "SAAS服务平台",
              href: "saas"
            },
            {
              name: "企业集采",
              href: "jzcg",
              outerHref: "https://b.ule.com/"
            }
          ]
        },
        {
          name: "农品电商平台",
          href: "Index",
          icon: "shopping-box"
        },
        // {
        //   name: "商家入驻",
        //   href: "Sjrz",
        //   outerHref: "https://merchant.ule.com/merJoinWeb/home/index"
        // },
        {
          name: "商家服务",
          href: "",
          icon: "select-box-sjfw",
          subMenu: [
            {
              name: "商家后台",
              outerHref: "https://merchant.ule.com/merWeb/"
            },
            {
              name: "学习中心",
              outerHref: "https://merchant.ule.com/collegeWeb/home"
            },
            {
              name: "合作招商",
              outerHref: "https://merchant.ule.com/merJoinWeb/home/index"
            },
            {
              name: "帮助中心",
              outerHref: "https://help.ule.com/merchant/"
            }
          ]
        },
        {
          name: "招标采购",
          href: "Zbgs"
        }
      ],
      nav: {
        Home: [
          {
            name: "首页",
            href: "/home"
            //id: 'ylyx-home',
          },
          {
            name: "产品及服务"
            //href: '#server',
            //id: 'ylyx-server'
          },
          {
            name: "商家入驻",
            href: "https://merchant.beta.ule.com/merJoinWeb/home/index"
            //id: 'ylyx-server'
          },
          {
            name: "关于我们",
            href: "/aboutus"
            //id: 'ylyx-aboutus'
          },
          {
            name: "邮乐线上购物",
            icon: ""
            //href: '#advan',
            //id: 'ylyx-advan'
          }
        ],
        Yzg: [
          {
            name: "首页",
            //href: '#home',
            id: "yzg-home"
          },
          {
            name: "云POS下载",
            //href: '#download',
            id: "yzg-download"
          },
          {
            name: "邮掌柜APP",
            //href: '#app',
            id: "yzg-app"
          },
          {
            name: "供应商加盟",
            //href: '#join',
            id: "yzg-join"
          },
          {
            name: "注册邮掌柜",
            href: "http://www.ule.com/yzg/2017/0607/register.html "
          }
        ],
        Ylxd: [
          {
            name: "首页",
            //href: '#home',
            id: "ylxd-home"
          },
          {
            name: "关于我们",
            //href: '#aboutus',
            id: "ylxd-aboutus"
          },
          {
            name: "精细选品",
            //href: '#jxxp',
            id: "ylxd-jxxp"
          },
          {
            name: "收益发放",
            //href: '#syff',
            id: "ylxd-syff"
          }
        ],
        Ylyx: [
          {
            name: "首页",
            //href: '#home',
            id: "ylyx-home"
          },
          {
            name: "服务",
            //href: '#server',
            id: "ylyx-server"
          },
          {
            name: "关于我们",
            //href: '#aboutus',
            id: "ylyx-aboutus"
          },
          {
            name: "我们优势",
            //href: '#advan',
            id: "ylyx-advan"
          },
          {
            name: "新闻资讯",
            //href: '#news',
            id: "ylyx-news"
          }
        ],
        Ylzb: [
          {
            name: "首页",
            //href: '#home',
            id: "ylzb-home"
          },

          {
            name: "我们的优势",
            //href: '#advan',
            id: "ylzb-advan"
          },
          {
            name: "我们的服务",
            //href: '#server',
            id: "ylzb-server"
          }
        ],
        Jtqycg: [
          {
            name: "首页",
            //href: '#home',
            id: "jtqycg-home"
          },

          {
            name: "系统优势",
            //href: '#xtys',
            id: "jtqycg-xtys"
          },
          {
            name: "供应链优势",
            //href: '#tylys',
            id: "jtqycg-tylys"
          },
          {
            name: "物流优势",
            //href: '#wlys',
            id: "jtqycg-wlys"
          }
        ],
        Yznp: [
          {
            name: "首页",
            //href: '#home',
            id: "yznp-home"
          },
          {
            name: "外销渠道",
            //href: '#wxqd',
            id: "yznp-wxqd"
          },
          {
            name: "质量品控",
            //href: '#zlpk',
            id: "yznp-zlpk"
          },
          {
            name: "电商运营",
            //href: '#dsyy',
            id: "yznp-dsyy"
          },
          {
            name: "产品品牌",
            //href: '#cppp',
            id: "yznp-cppp"
          },
          {
            name: "产学结合",
            //href: '#cxjh',
            id: "yznp-cxjh"
          }
        ],
        Jfsc: [
          {
            name: "首页",
            //href: '#home',
            id: "jfsc-home"
          },

          {
            name: "积分营销服务",
            //href: '#marketing',
            id: "jfsc-marketing"
          },
          {
            name: "核心优势",
            //href: '#core',
            id: "jfsc-core"
          },
          {
            name: "服务流程",
            //href: '#flow',
            id: "jfsc-flow"
          },
          {
            name: "应用案例",
            //href: '#case',
            id: "jfsc-case"
          }
        ],
        Yel: [
          {
            name: "首页",
            //href: '#home',
            id: "yel-home"
          },
          {
            name: "准入条件",
            //href: '#tj',
            id: "yel-tj"
          },
          {
            name: "邮你贷",
            //href: '#ynd',
            id: "yel-ynd"
          },
          {
            name: "邮你付",
            //href: '#ynf',
            id: "yel-ynf"
          }
        ],
        Gywm: [
          {
            name: "首页",
            //href: '#home',
            id: "gywm-home"
          },
          {
            name: "邮乐特色",
            //href: '#ylts',
            id: "gywm-ylts"
          },
          {
            name: "全程配送",
            //href: '#qcps',
            id: "gywm-qcps"
          },
          {
            name: "发展历程",
            //href: '#fzlc',
            id: "gywm-fzlc"
          },
          {
            name: "采购公告公示",
            href: `${this.$basePath}/Zbgs`,
            id: "gywm-fzlc"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(["isIn919", "activeInfo919"])
  },
  // props: {
  //   nav: {
  //     type: Array,
  //     default: "",
  //   }
  // },
  mounted() {},
  created() {
    this.$router.onReady(() => {
      this.pathName = this.$route.name;
    });
  },
  methods: {
    init() {},
    isServer() {
      return (
        this.pathName == "Yzg" ||
        this.pathName == "Yznp" ||
        this.pathName == "Ylsc" ||
        this.pathName == "Ylxd" ||
        this.pathName == "Ylzb" ||
        this.pathName == "Ylyx" ||
        this.pathName == "Ysh" ||
        this.pathName == "Yel" ||
        this.pathName == "Saas" ||
        this.pathName == "Wlcx"
      );
    },
    isServer2() {
      return (
        this.pathName == "Gsjj" ||
        this.pathName == "Zzjg" ||
        this.pathName == "Fzlc" ||
        this.pathName == "Qywh"
      );
    },
    innerHrefOpen(path) {
      //this.$router.push(`/${path}`);
      let originName = location.origin;
      path = `${originName}${this.$basePath}/${path}`;
      window.open(path);
    },
    toOpenPage(item) {
      let originName = location.origin;
      let path = "";
      if (item.outerHref) {
        path = `${item.outerHref}`;
      } else if (item.href) {
        path = `${originName}${this.$basePath}/${item.href}`;
      } else {
        return;
      }
      window.open(path);
    },
    signOutFun() {
      this.signOut();
      this.$router.push("/");
    },
    // 锚点跳转
    goAnchor(selector, index) {
      this.currIndex = index;
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
      });
    }
  },
  store
};
</script>

<style lang="less" scoped>
.header-module {
  width: 100%;
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 0px 57px 0px rgba(0, 0, 0, 0.15);
  color: rgba(102, 102, 102, 1);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  .header-919 {
    background: #ffb657;
    .header-919-inner {
      width: 1500px;
      height: 100px;
      // width: 78vw;
      // height: 5.2vw;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .header-box {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    //justify-content: space-between;
    align-items: center;
    width: 1300px;
    height: 100px;
    margin: 0 auto;
    //background: rgba(255,255,255,0.5);
    position: relative;
    .logo {
      width: 171px;
      height: 58px;
      margin-right: 60px;
      cursor: pointer;
      .floor1 {
        .logo-yz {
          width: 91px;
          height: 27px;
        }
        i {
          display: inline-block;
          width: 1px;
          height: 17px;
          background: #ccc;
          margin: 0 10px 2px 13px;
        }
        .logo-ule {
          width: 43px;
          height: 21px;
        }
      }
      .floor2 {
        display: inline-block;
        margin-top: 8px;
        font-size: 12px;
        color: #231716;
        background: #f2f2f2;
        border-radius: 3px;
        padding: 4px 6px;
      }
    }
    .slogan {
      width: 171px;
      height: 37px;
      margin-left: 22px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .menu-box {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      .menu-item {
        //min-width: 650px;
        height: 28px;
        ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          list-style: none;
          li {
            font-size: 16px;
            height: 28px;
            line-height: 28px;
            padding: 0 24px;
            font-weight: bold;
            color: rgba(0, 0, 0, 1);
            position: relative;
            .icon-pre {
              position: absolute;
              left: 0;
              top: 3px;
            }
            &.in919 {
              .icon-pre {
                top: -1px;
                left: -8px;
              }
              &.shopping-box {
                margin-left: 16px;
              }
            }

            &.shopping-box {
              // background: url(https://i0.ulecdn.com/sites/ule/img/home/new/icon-shopping.png)
              //   no-repeat left center;
              margin-left: 12px;
              // &.on {
              //   background: url("https://i0.ulecdn.com/sites/ule/img/home/new/icon-shopping-active.png")
              //     no-repeat left center;
              // }
            }
            &.select-box,
            &.select-box-gywm,
            &.select-box-sjfw {
              //padding-right: 20px;
              margin-right: 16px;
              background: url(https://i0.ulecdn.com/sites/ule/img/home/new/icon-arr-down.png)
                no-repeat right center;
              .list-box {
                display: block;
                position: absolute;
                top: 28px;
                left: -16px;
                width: 208px;
                height: 0px;
                background: #fff;
                overflow: hidden;
                transition: all 0.5s ease-in-out;
                span {
                  display: block;
                  line-height: 50px;
                  text-align: center;
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                  &:hover {
                    font-weight: bold;
                    color: #d7171b;
                    cursor: pointer;
                  }
                }
              }
              &:hover {
                .list-box {
                  //display: block;
                  height: 510px;
                }
                background: url(https://i0.ulecdn.com/sites/ule/img/home/new/icon-arr-up.png)
                  no-repeat right center;
              }
            }
            &.select-box-gywm {
              &:hover {
                .list-box {
                  height: 200px;
                }
              }
            }
            &.select-box-sjfw {
              &:hover {
                .list-box {
                  height: 200px;
                }
              }
            }
            a {
              display: block;
              text-decoration: none;
              color: #333;
              &:hover {
                color: #d9534f;
              }
              &.on {
                //border-bottom: 2px solid rgba(214, 11, 11, 1);
                font-weight: bold;
                color: rgba(214, 11, 11, 1);
              }
            }
          }
        }
      }
    }
    .user-center {
      margin-left: 20px;
      width: 100px;
      text-align: center;
      a {
        color: #333;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/SubHeader.vue